import { Observation } from "@medplum/fhirtypes";

export function averageObservationsByDate(observations: Observation[]): Observation[] {
    const groupedObservations: { [date: string]: Observation[] } = {};
  
    // Group observations by date
    observations.forEach(obs => {
      const date = obs.effectiveDateTime?.split('T')[0] || '';
      if (!groupedObservations[date]) {
        groupedObservations[date] = [];
      }
      groupedObservations[date].push(obs);
    });
  
    // Average observations for each date
    const averagedObservations: Observation[] = [];
    for (const [date, obsGroup] of Object.entries(groupedObservations)) {
      if (obsGroup.length === 1) {
        averagedObservations.push(obsGroup[0]);
      } else {
        const totalValue = obsGroup.reduce((sum, obs) => {
          return sum + (obs.valueQuantity?.value || 0);
        }, 0);
        let avgValue = totalValue / obsGroup.length;
        if (obsGroup[0].code.text?.toLowerCase() == 'steps')  avgValue = totalValue;
        const averagedObs: Observation = {
          ...obsGroup[0],
          valueQuantity: {
            ...obsGroup[0].valueQuantity,
            value: Number(avgValue.toFixed(2))
          }
        };
        averagedObservations.push(averagedObs);
      }
    }
  
    return averagedObservations;
  }